import { Link, useParams } from "react-router-dom"
import MainLayout from "../../components/layouts/MainLayout"
import { useEffect, useState } from "react"
import { Alert, Spin, Collapse, Image, Tag } from "antd"
import { PlusCircleOutlined, LeftCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import { FactureApi } from "../../api/factureApi"
import { DateFormat } from "../../utils/formatDate"
import Money from "../../components/Money"
const { Panel } = Collapse;

const DetailsFactureView = () => {
    const { id } = useParams()
    const [facture, setFacture] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const abortController = new AbortController()

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await FactureApi.getFactureDetails(`${id}`, abortController.signal);
            setFacture(res.data);
        } catch (err) {
            setError("Impossible de charger les détails de la facture.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return <MainLayout>
        <div className="container mx-auto p-6">
            <div className="flex justify-between">
                <h1 className="text-3xl font-semibold mb-6">Détails de la facture {facture?.numero_facture}</h1>
                <Link to={`/factures`}><LeftCircleOutlined /> Retour  </Link>
            </div>

            {loading && <Spin size="large" />}
            {error && <Alert message={error} type="error" />}
            {!loading && !error && facture && (
                <div className="bg-white p-6 rounded-lg shadow-md">
                    {/* Informations de la facture */}
                    <Collapse defaultActiveKey={['1']} expandIconPosition="start">
                        <Panel header="Informations de la facture" key="1" extra={<PlusCircleOutlined />}>
                            <div className="space-y-4">
                                <p><strong>N° facture :</strong> {facture?.numero_facture}</p>
                                <p><strong>Montant TTC :</strong> <Money amount={facture?.montant_total_ttc} /></p>
                                <p><strong>Commission :</strong> <Money amount={facture?.montant_total_commissione} /></p>
                                <p><strong>Date de dépôt :</strong> {DateFormat.formatDate(facture?.date_emission)}</p>
                                <p><strong>Statut :</strong> {facture?.statut ? <Tag>{facture.statut}</Tag> : 'Non renseigné'}</p>
                            </div>
                        </Panel>
                    </Collapse>

                    {/* Commande associée */}
                    <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
                        <Panel header="Commande associée" key="2" extra={<PlusCircleOutlined />}>
                            <div className="space-y-4">
                                <p><strong>N° commande :</strong> {facture?.order?.order_number || "Non renseigné"}</p>
                                <p><strong>Montant de la commande :</strong> {facture?.order?.total_amount ? <Money amount={facture.order.total_amount} /> : "Non renseigné"}</p>
                                <p><strong>Statut de la commande :</strong> {facture?.order?.status || "Non renseigné"}</p>
                                {facture?.order?.id && (
                                    <Link to={`/commandes/${facture.order.id}/details`}>Voir la commande</Link>
                                )}
                            </div>
                        </Panel>
                    </Collapse>

                    {/* Informations vendeur */}
                    <Collapse defaultActiveKey={['3']} expandIconPosition="start" className="mt-4">
                        <Panel header="Informations vendeur" key="3" extra={<PlusCircleOutlined />}>
                            <div className="space-y-4">
                                <p><strong>Nom :</strong> {facture?.vendeur ? `${facture.vendeur.name ?? ''} ${facture.vendeur.lastname ?? ''}` : "Non renseigné"}</p>
                                <p><strong>Contact :</strong> {facture?.vendeur?.contact || "Non renseigné"}</p>
                            </div>
                        </Panel>
                    </Collapse>

                    {/* Informations client */}
                    <Collapse defaultActiveKey={['4']} expandIconPosition="start" className="mt-4">
                        <Panel header="Informations client" key="4" extra={<PlusCircleOutlined />}>
                            <div className="space-y-4">
                                <p><strong>Nom :</strong> {facture?.client ? `${facture.client.name ?? ''} ${facture.client.lastname ?? ''}` : "Non renseigné"}</p>
                                <p><strong>Contact :</strong> {facture?.client?.contact || "Non renseigné"}</p>
                            </div>
                        </Panel>
                    </Collapse>

                    {/* Image de la facture */}
                    <Collapse defaultActiveKey={['5']} expandIconPosition="start" className="mt-4">
                        <Panel header="Image de la facture" key="5" extra={<PlusCircleOutlined />}>
                            {facture?.image_facture ? (
                                <div className="space-y-4">
                                    <Image
                                        src={facture.image_facture}
                                        alt={facture?.numero_facture || "Facture"}
                                        width={220}
                                    />
                                    <div>
                                        <a href={facture.image_facture} download target="_blank" rel="noreferrer">
                                            <DownloadOutlined /> Télécharger la facture
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <p>Aucune image n'a été transmise pour cette facture.</p>
                            )}
                        </Panel>
                    </Collapse>
                </div>
            )}
        </div>
    </MainLayout>
}
export default DetailsFactureView
